import { TaskListItem } from './task-list-item';

export class ContainerPlacingTaskListItem extends TaskListItem {
    public usePaperBag: boolean;
}
